__turbopack_context__.v({
  "container": "Spinner-module__SVgIOG__container",
  "error": "Spinner-module__SVgIOG__error",
  "simpleSolid": "Spinner-module__SVgIOG__simpleSolid",
  "simpleSpinner": "Spinner-module__SVgIOG__simpleSpinner",
  "simpleTinted": "Spinner-module__SVgIOG__simpleTinted",
  "solid": "Spinner-module__SVgIOG__solid",
  "spin": "Spinner-module__SVgIOG__spin",
  "spinner": "Spinner-module__SVgIOG__spinner",
  "tinted": "Spinner-module__SVgIOG__tinted",
  "title": "Spinner-module__SVgIOG__title",
});
